export default __webpack_public_path__ + "static/open-graph-protcol-image-e839aec1d06fc809017798456425d2d7.jpg";